<script setup lang="ts">

// Current version
const currentVersion = '1.9.10';

const newFeatures_1910 = [
  'Added partial shareholder withdrawal feature in the shareholder screen.',
  'Enabled editing of employee accounts after they are linked.',
  'Updated FD monthly deposit functionality.'
]

const newFeaturesKannada_1910 = [
  'ಹಂಚಿಕೆದಾರರ ಪರದೆಯಲ್ಲಿ ಭಾಗಶಃ ಹಂಚಿಕೆದಾರರ ಹಿಂಪಡೆಯುವ ವೈಶಿಷ್ಟ್ಯವನ್ನು ಸೇರಿಸಲಾಗಿದೆ.',
  'ಲಿಂಕ್ ಮಾಡಿದ ನಂತರ ನೌಕರರ ಖಾತೆಗಳನ್ನು ಸಂಪಾದಿಸಲು ಅವಕಾಶ ನೀಡಲಾಗಿದೆ.',
  'ಎಫ್‌ಡಿ ಮಾಸಿಕ ಠೇವಣಿ ಕಾರ್ಯವನ್ನು ನವೀಕರಿಸಲಾಗಿದೆ.'
]

const newFeatures_199 = [
  'Added salary account for employees and automated expense entry for salary accounts.',
]

const newFeaturesKannada_199 = [
  'ನೌಕರರಿಗಾಗಿ ಸಂಬಳ ಖಾತೆಯನ್ನು ಸೇರಿಸಲಾಗಿದೆ ಮತ್ತು ಸಂಬಳ ಖಾತೆಗಳಿಗಾಗಿ ಖರ್ಚಿನ ನಮೂದನ್ನು ಸ್ವಯಂಚಾಲಿತಗೊಳಿಸಲಾಗಿದೆ.'
]
</script>

<template>
  <main class="dashboard-container h-full">
    <!-- Version Banner -->
    <div class="version-banner">
      <div class="version-content">
        <div class="version-number">v{{ currentVersion }}</div>
        <div class="version-text">Swift Banking Application</div>
      </div>
      <div class="version-date">Released: {{ "Sep 10, 2025" }}</div>
    </div>

    <!-- Release Notes Container -->
    <div class="release-container">
      <!-- English Release Notes -->
      <div class="release-column">
        <div class="release-header">
          <h2>What's New</h2>
        </div>
        
        <!-- Current Version -->
        <div class="release-card current">
          <div class="release-title">
            <h3>Version 1.9.10</h3>
            <span class="release-tag">Latest</span>
          </div>

          <ul class="feature-list">
            <li v-for="(feature, index) in newFeatures_1910" :key="`1910-en-${index}`">
              {{ feature }}
            </li>
          </ul>
        </div>

        <div class="release-card">
          <div class="release-title">
            <h3>Version 1.9.9</h3>
          </div>
          
          <ul class="feature-list">
            <li v-for="(feature, index) in newFeatures_199" :key="`199-en-${index}`">
              {{ feature }}
            </li>
          </ul>
        </div>
      </div>
      
      <!-- Kannada Release Notes -->
      <div class="release-column">
        <div class="release-header">
          <h2>ಹೊಸದು ಏನು?</h2>
        </div>
        
        <!-- Current Version -->
        <div class="release-card current">
          <div class="release-title">
            <h3>ಆವೃತ್ತಿ 1.9.10</h3>
            <span class="release-tag">ಇತ್ತೀಚಿನದು</span>
          </div>
          
          <ul class="feature-list">
            <li v-for="(feature, index) in newFeaturesKannada_1910" :key="`1910-kn-${index}`">
              {{ feature }}
            </li>
          </ul>
        </div>
        
        <!-- Previous Versions -->
        <div class="release-card">
          <div class="release-title">
            <h3>ಆವೃತ್ತಿ 1.9.9</h3>
          </div>

          <ul class="feature-list">
            <li v-for="(feature, index) in newFeaturesKannada_199" :key="`199-kn-${index}`">
              {{ feature }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
.dashboard-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 1.5rem;
  min-height: calc(100vh - 100px);
}

.version-banner {
  background: linear-gradient(135deg, #1e40af, #3b82f6);
  color: white;
  border-radius: 8px;
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.version-content {
  display: flex;
  align-items: baseline;
  gap: 1rem;
}

.version-number {
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.version-text {
  font-size: 1.25rem;
  font-weight: 300;
}

.version-date {
  font-size: 0.875rem;
  opacity: 0.9;
}

.release-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.release-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.release-header {
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.75rem;
}

.release-header h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.release-card {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #e2e8f0;
}

.release-card.current {
  border-left-color: #3b82f6;
  background-color: #f0f9ff;
}

.release-title {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.75rem;
}

.release-title h3 {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
  color: #0f172a;
}

.release-tag {
  background-color: #3b82f6;
  color: white;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-weight: 600;
}

.feature-list {
  margin: 0;
  padding-left: 1.5rem;
  list-style-type: disc;
  list-style-position: outside;
}

.feature-list li {
  margin-bottom: 0.75rem;
  line-height: 1.5;
  color: #334155;
  padding-left: 0.5rem;
  text-align: left;
}

.feature-list li:last-child {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .version-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .version-date {
    align-self: flex-end;
  }
  
  .release-container {
    grid-template-columns: 1fr;
  }
}
</style>

